(() => {
	const DRAWER_SELECTOR =
		"menu-drawer.mobile-facets__wrapper > details.disclosure-has-popup";
	const SUMMARY_SELECTOR = ":scope > summary";
	const DETAIL_SELECTOR =
		".mobile-facets__main details.mobile-facets__details.js-filter";
	const SINGLE_GROUP_CLASS = "shop-filter-single-group";
	const INLINE_CLASS = "shop-filter-mobile-inline";
	const EXPANDED_CLASS = "shop-filter-mobile-expanded";

	const isMobile = () => window.matchMedia("(max-width: 749px)").matches;

	const syncSingleGroupState = (drawer) => {
		if (!drawer) return;

		const filterDetails = drawer.querySelectorAll(DETAIL_SELECTOR);
		drawer.classList.toggle(SINGLE_GROUP_CLASS, filterDetails.length === 1);
		drawer.classList.add(INLINE_CLASS);

		const summaryLabel = drawer.querySelector(".mobile-facets__open > span");
		const singleGroupDetail = filterDetails.length === 1 ? filterDetails[0] : null;
		const groupLabel = singleGroupDetail?.querySelector(
			".mobile-facets__summary span"
		);

		if (summaryLabel && groupLabel) {
			const customLabel =
				"Filter by " + groupLabel.textContent.trim().toLowerCase();
			summaryLabel.textContent = customLabel;
			drawer.dataset.shopFilterLabel = customLabel;
		}
	};

	const getSingleGroupDetail = (drawer) => {
		if (!drawer.classList.contains(SINGLE_GROUP_CLASS)) return null;
		return drawer.querySelector(DETAIL_SELECTOR);
	};

	const ensureInlineClearButton = (drawer) => {
		const singleGroupDetail = getSingleGroupDetail(drawer);
		if (!singleGroupDetail) return;

		const submenu = singleGroupDetail.querySelector(".mobile-facets__submenu");
		const list = submenu?.querySelector(".mobile-facets__list");
		if (!submenu || !list) return;

		let clearButton = submenu.querySelector(".shop-filter-clear");

		if (!clearButton) {
			clearButton = document.createElement("button");
			clearButton.type = "button";
			clearButton.className = "shop-filter-clear";
			clearButton.textContent = "CLEAR FILTERS";
			submenu.appendChild(clearButton);

			clearButton.addEventListener("click", () => {
				const checkedInputs = submenu.querySelectorAll(
					".mobile-facets__checkbox:checked"
				);

				checkedInputs.forEach((input) => {
					input.checked = false;
				});

				const firstCheckedInput = checkedInputs[0];
				if (firstCheckedInput) {
					firstCheckedInput.dispatchEvent(
						new Event("change", { bubbles: true })
					);
				}
			});
		}

		const hasActiveFilters =
			submenu.querySelectorAll(".mobile-facets__checkbox:checked").length > 0;
		clearButton.classList.toggle("visible", hasActiveFilters);
	};

	const closeInlineDrawer = (drawer) => {
		const summary = drawer.querySelector(SUMMARY_SELECTOR);
		const singleGroupDetail = getSingleGroupDetail(drawer);
		drawer.classList.remove(EXPANDED_CLASS, "menu-opening");
		drawer.removeAttribute("open");
		if (singleGroupDetail) {
			singleGroupDetail.classList.remove("menu-opening");
			singleGroupDetail.removeAttribute("open");
		}
		if (summary) {
			summary.setAttribute("aria-expanded", "false");
		}
		document.body.classList.remove("overflow-hidden-mobile");
	};

	const openInlineDrawer = (drawer) => {
		const summary = drawer.querySelector(SUMMARY_SELECTOR);
		const singleGroupDetail = getSingleGroupDetail(drawer);
		drawer.setAttribute("open", "");
		drawer.classList.add(EXPANDED_CLASS);
		drawer.classList.remove("menu-opening");
		if (singleGroupDetail) {
			singleGroupDetail.setAttribute("open", "");
			singleGroupDetail.classList.add("menu-opening");
		}
		if (summary) {
			summary.setAttribute("aria-expanded", "true");
		}
		document.body.classList.remove("overflow-hidden-mobile");
	};

	const toggleInlineDrawer = (drawer) => {
		if (drawer.hasAttribute("open")) {
			closeInlineDrawer(drawer);
		} else {
			openInlineDrawer(drawer);
		}
	};

	const bindInlineToggle = (drawer) => {
		if (!drawer || drawer.dataset.shopFilterBound === "true") return;

		const summary = drawer.querySelector(SUMMARY_SELECTOR);
		if (!summary) return;

		summary.addEventListener(
			"click",
			(event) => {
				if (!isMobile()) return;

				event.preventDefault();
				event.stopImmediatePropagation();
				toggleInlineDrawer(drawer);
			},
			true
		);

		drawer.dataset.shopFilterBound = "true";
	};

	const syncDrawer = (drawer) => {
		syncSingleGroupState(drawer);
		ensureInlineClearButton(drawer);
		bindInlineToggle(drawer);

		if (isMobile()) {
			if (drawer.dataset.shopFilterInitialized !== "true") {
				closeInlineDrawer(drawer);
				drawer.dataset.shopFilterInitialized = "true";
			}
			return;
		}

		if (!isMobile()) {
			drawer.classList.remove(EXPANDED_CLASS);
			drawer.removeAttribute("open");
			const summary = drawer.querySelector(SUMMARY_SELECTOR);
			if (summary) {
				summary.setAttribute("aria-expanded", "false");
			}
			delete drawer.dataset.shopFilterInitialized;
		}
	};

	document.addEventListener(
		"toggle",
		(event) => {
			const drawer = event.target;
			if (!(drawer instanceof HTMLDetailsElement)) return;
			if (!drawer.matches(DRAWER_SELECTOR)) return;

			if (!isMobile()) {
				syncDrawer(drawer);
				return;
			}

			document.body.classList.remove("overflow-hidden-mobile");
		},
		true
	);

	const init = () => {
		document.querySelectorAll(DRAWER_SELECTOR).forEach(syncDrawer);
	};

	let initFrame = null;
	const scheduleInit = () => {
		if (initFrame) cancelAnimationFrame(initFrame);
		initFrame = requestAnimationFrame(() => {
			init();
		});
	};

	document.addEventListener("DOMContentLoaded", init);

	document.addEventListener("shopify:section:load", () => {
		scheduleInit();
	});

	window.addEventListener("resize", scheduleInit);

	const observer = new MutationObserver(() => {
		scheduleInit();
	});

	observer.observe(document.documentElement, {
		childList: true,
		subtree: true,
	});
})();
